import styled from 'styled-components';

export const Text = styled.h3`
  font-size:24px;
  color: ${props => props.color};
  width:100%;
`;
